import { render, staticRenderFns } from "./EndorsementPrintTemplates.vue?vue&type=template&id=349d286c&scoped=true"
import script from "./EndorsementPrintTemplates.vue?vue&type=script&lang=ts"
export * from "./EndorsementPrintTemplates.vue?vue&type=script&lang=ts"
import style0 from "./EndorsementPrintTemplates.vue?vue&type=style&index=0&id=349d286c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d286c",
  null
  
)

export default component.exports